import { ORDINE_VENDITA_COLUMNS } from '../_models/pianificazione/columns/ordine-vendita.columns';
import { OV_LIST_COLUMNS, getOvColumnLabel } from '../_models/ordine-vendita-list-columns';
import { CampoUtenteDef } from '../_models/CampoUtenteDef';

// Larghezze CSS Grid per la tabella Excel-like degli Ordini Clienti.
// minmax(min, max): il `min` evita che la colonna collassi sotto la soglia
// di leggibilità, il `max` (fr o px) consente l'espansione su display larghi.
// La somma dei `min` può superare la larghezza del container su laptop 13"/tablet:
// in quel caso il wrapper genitore deve essere `overflow-x-auto`.
// Feature 064 — derivate dal registry colonne di lista (fonte unica di verità). Le chiavi
// dinamiche `Cu_<codice>` (Campi Utente) non sono nel registry statico: usano il fallback.
export const ORDINE_VENDITA_GRID_WIDTHS: Record<string, string> =
  OV_LIST_COLUMNS.reduce<Record<string, string>>((acc, c) => {
    acc[c.key] = c.width;
    return acc;
  }, {});

export const ORDINE_VENDITA_ACTIONS_COL_WIDTH = '64px';

const COLUMN_LABEL_MAP = new Map(ORDINE_VENDITA_COLUMNS.map(c => [c.key, c.label]));

export function buildOrdineVenditaGridTemplate(visibleColumns: readonly string[]): string {
  const cols = (visibleColumns ?? [])
    .map(c => ORDINE_VENDITA_GRID_WIDTHS[c] ?? 'minmax(100px, 1fr)')
    .join(' ');
  return `${cols} ${ORDINE_VENDITA_ACTIONS_COL_WIDTH}`;
}

export function getOrdineVenditaColumnLabel(key: string): string {
  return COLUMN_LABEL_MAP.get(key) ?? key;
}

// Etichette delle colonne di lista Ordini Clienti — risolte dal registry (feature 064),
// la stessa sorgente usata dal modale "Colonne" e dalle celle, così l'header dell'elenco
// attività del Dettaglio Pianifica resta coerente con la selezione del modale. Passando le
// definizioni Campi Utente attive si risolvono anche le etichette delle colonne `Cu_<codice>`
// (altrimenti l'header mostrerebbe la chiave grezza `Cu_<codice>`).
export function getOrdineVenditaListColumnLabel(
  key: string,
  campiUtenteDefs?: CampoUtenteDef[]
): string {
  return getOvColumnLabel(key, campiUtenteDefs);
}
